import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { decryptPW, getThousandComma } from "../../ApiTS/ApiCommonTS";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import Flex from "../../components/DefaultStyles/Flex";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import YoutubeMatchingInfoFilter from "../../components/pages/Party/Youtube/YoutubeMatchingInfoFilter";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { TotalCount } from "../Users/UserInfo";
import LineBtn from "../../components/Button/LineBtn";
import { useRecoilState, useRecoilValue } from "recoil";
import { authType, userDataType } from "../Login";
import UplusCodeLogModal from "../../components/pages/Party/UplusMatchingInfo/UplusCodeLogModal";
import GPTSoloLogModal from "../../components/pages/Party/GPT_Solo/GPTSoloLogModal";
import GPTSoloUpdateModal from "../../components/pages/Party/GPT_Solo/GPTSoloUpdateModal";
import {
  copyMatchingUserInfoForExcel,
  getYTStateString,
  IYoutube,
  IYoutubeState,
  youtubeInfoFilterState,
} from "./YoutubeMatchingInfo";
import CommentModal from "../../components/pages/Users/UserDetail/CommentModal/CommentModal";
import GPTSoloCommentInputModal from "../../components/pages/Party/GPT_Solo/GPTSoloCommentInputModal";
import GptSoloMatchingInfoFilter from "../../components/pages/Party/GPT_Solo/GPTSoloInfoFilter";
import ToggleBtn from "../../components/Button/ToggleBtn";
import {
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../components/pages/Benefit/Point/PointTab";

type PerplexityMatchingTab = 0 | 1;

export default function PerplexitySoloMatchingInfo() {
  const navigate = useNavigate();
  const auth = useRecoilValue(authType);
  const userData = useRecoilValue(userDataType);

  const [filter, setFilter] = useRecoilState(youtubeInfoFilterState);
  const [page, setPage] = useState(filter?.page ?? 0);
  const [matchingTab, setMatchingTab] = useState<PerplexityMatchingTab>(
    filter?.stateValue === "3" ? 1 : 0,
  );
  const isAll = matchingTab === 0 ? 0 : 1;

  const handleMatchingTabChange = (nextTab: PerplexityMatchingTab) => {
    setMatchingTab(nextTab);
    setPage(0);
    setFilter((prev) => ({
      ...prev,
      page: 0,
      stateValue:
        nextTab === 1 ? "3" : prev.stateValue === "3" ? "" : prev.stateValue,
    }));
  };

  const buildProxyPartyUrl = () =>
    `proxyparty?page=${page}&size=10&isall=${isAll}&servsubsid=29500` +
    (filter?.searchValue !== ""
      ? `&${filter?.searchType}=${filter?.searchValue}`
      : ``) +
    (matchingTab === 1
      ? `&ytstate=3`
      : filter?.stateValue !== "" && filter?.stateValue !== "3"
        ? `&ytstate=${filter?.stateValue}`
        : ``) +
    (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
      ? `&datetype=${filter?.dateType}&startdate=${
          filter?.startdate
        }&enddate=${dayjs(filter?.enddate)
          ?.add(1, "day")
          ?.format("YYYY-MM-DD")}`
      : ``);

  useEffect(() => {
    setFilter((prev) => ({ ...prev, page: 0 }));
  }, []);

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: buildProxyPartyUrl(),
  });
  const [viewLog, setViewLog] = useState({
    modal: false,
    partyid: 0,
  });

  const [updateModal, setUpdateModal] = useState<{
    visible: boolean;
    data: IYoutube;
    servsubsid?: number;
    dueDate?: string;
  }>({
    visible: false,
    data: {} as IYoutube,
    servsubsid: undefined,
    dueDate: undefined,
  });

  const [commentInputModal, setCommentInputModal] = useState<{
    visible: boolean;
    uid: number;
    name: string;
    nickname: string;
    partyid: number;
    servsubsid: number;
  }>({
    visible: false,
    uid: 0,
    name: "",
    nickname: "",
    partyid: 0,
    servsubsid: 0,
  });

  const [commentModal, setCommentModal] = useState<{
    visible: boolean;
    uid: number;
    name: string;
    nickname: string;
    partyid: number;
    servsubsid: number;
    content: string;
  }>({
    visible: false,
    uid: 0,
    name: "",
    nickname: "",
    partyid: 0,
    servsubsid: 0,
    content: "",
  });

  const tableHead = [
    "Index",
    // String(userData?.collabo) === "0" ? "Collabo" : undefined,
    "로그 확인",
    "접수 상태",
    String(userData?.collabo) === "0" ? "PID" : undefined,
    String(userData?.collabo) === "0" ? "UID" : undefined,
    "이름",
    "닉네임",
    // "기간",
    // "목표일",
    "ID",
    "PW",
    // "생년월일",

    // "ROLE",
    // "파티 상태",
    "최초 등록일",
    "최종 수정일",
    "관리자",
    "코멘트",
  ];

  const excelHead = tableHead?.filter(
    (a) =>
      a !== "" &&
      a !== "선택" &&
      a !== "ID" &&
      a !== "로그 확인" &&
      a !== "신청자" &&
      a !== "최종 업데이트",
  );

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "유플러스 결합 정보를 가져오는 데에 실패하였습니다.",
      );
    }
  }, [error]);

  return (
    <>
      <MatchingTabContainer>
        <PointTabColumn onClick={() => handleMatchingTabChange(0)}>
          <MatchingTabText isActive={matchingTab === 0}>
            처리완료 제외
          </MatchingTabText>
        </PointTabColumn>

        <PointTabColumn onClick={() => handleMatchingTabChange(1)}>
          <MatchingTabText isActive={matchingTab === 1}>
            처리완료
          </MatchingTabText>
        </PointTabColumn>
      </MatchingTabContainer>

      <GptSoloMatchingInfoFilter
        key={matchingTab}
        pageResetEvent={() => setPage(0)}
        excludeCompletedStatus={matchingTab === 0}
        isCompletedTab={matchingTab === 1}
      />

      <Flex
        style={{ justifyContent: "flex-start", margin: "12px 0" }}
        gapSize={10}
      >
        <LineBtn
          btnText="새로고침"
          btnColor="mint"
          btnClickEvent={() => {
            fetchData({
              method: "get",
              url: buildProxyPartyUrl(),
            });
          }}
        />

        {/* <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
          }}
        >
          <ToggleBtn
            check={isAll === 1}
            checkEvent={() => setIsAll(isAll === 1 ? 0 : 1)}
          />
          처리완료 포함
        </label> */}
      </Flex>

      <LineBox key={"youtube-matching-info-box"}>
        <Table tableHeadData={tableHead} tableMinWidth={1120}>
          <>
            {response?.data?.items?.map((d: IYoutube, index: number) => {
              return (
                <TableBody key={d?.partyid}>
                  <TableBodyItem isKeepAll={true}>
                    {String(userData?.collabo) === "0" ? (
                      <button
                        type="button"
                        title="PID, UID, 이름, 닉네임 복사"
                        aria-label="PID, UID, 이름, 닉네임 복사"
                        onClick={() => {
                          void copyMatchingUserInfoForExcel(d);
                        }}
                        style={{
                          minWidth: "32px",
                          padding: "4px 8px",
                          border: "1px solid #D4D9E1",
                          borderRadius: "5px",
                          background: "#FFFFFF",
                          color: "inherit",
                          font: "inherit",
                          cursor: "pointer",
                        }}
                      >
                        {response?.data?.totalCount - (page * 10 + index)}
                      </button>
                    ) : (
                      response?.data?.totalCount - (page * 10 + index)
                    )}
                  </TableBodyItem>
                  {/* {sessionStorage.getItem("collabo") === "0" && (
                    <TableBodyItem>
                      {d?.collabo}: {getCollaboString(d?.collabo ?? 1)}
                    </TableBodyItem>
                  )} */}

                  <TableBodyItem>
                    <LineBtn
                      btnText="보기"
                      btnClickEvent={() =>
                        setViewLog({
                          modal: true,
                          partyid: d?.partyid ?? 0,
                        })
                      }
                    />
                  </TableBodyItem>
                  <TableBodyItem>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "16px",
                          fontSize: "13px",
                          fontWeight: 600,
                          backgroundColor:
                            d?.ytstate === 1
                              ? "#FFF3E0"
                              : d?.ytstate === 2
                                ? "#E3F2FD"
                                : d?.ytstate === 3
                                  ? "#E8F5E9"
                                  : d?.ytstate === 4 || d?.ytstate === 5
                                    ? "#FFEBEE"
                                    : "#F5F5F5",
                          color:
                            d?.ytstate === 1
                              ? "#E65100"
                              : d?.ytstate === 2
                                ? "#1565C0"
                                : d?.ytstate === 3
                                  ? "#2E7D32"
                                  : d?.ytstate === 4 || d?.ytstate === 5
                                    ? "#C62828"
                                    : "#616161",
                        }}
                      >
                        {getYTStateString(d?.ytstate)}{" "}
                      </span>
                      {d?.duedate && d?.ytstate === 7 && (
                        <span
                          style={{
                            color:
                              dayjs(d?.duedate).format("YYYY-MM-DD") >
                              dayjs().format("YYYY-MM-DD")
                                ? "#000000"
                                : "#D32F2F",
                            fontWeight:
                              dayjs(d?.duedate).format("YYYY-MM-DD") >
                              dayjs().format("YYYY-MM-DD")
                                ? "500"
                                : "900",
                          }}
                        >
                          {`${dayjs(d?.duedate).format("YYYY-MM-DD")}`}
                        </span>
                      )}
                      <LineBtn
                        btnText="상태변경하기"
                        btnClickEvent={() => {
                          setUpdateModal({
                            visible: true,
                            data: d,
                            servsubsid: d?.servsubsid,
                            dueDate: d?.duedate,
                          });
                        }}
                        // disabled={d?.ytstate === 3 ? true : false}
                        disabled={false}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                        }}
                      />
                    </div>
                  </TableBodyItem>
                  {String(userData?.collabo) === "0" && (
                    <TableBodyItem
                      isKeepAll={true}
                      clickable={d?.partyid ? true : false}
                      onClick={() => {
                        if (d?.partyid > 0) {
                          setFilter((prev) => ({ ...prev, page }));
                          navigate(`/party/info/${d?.partyid ?? 0}`);
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <span>{d?.partyid ?? "-"}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                              String(d?.partyid ?? ""),
                            );
                            toast.success("PID가 복사되었습니다.");
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "8px 14px",
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "#555",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#D0D0D0")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#F5F5F5")
                          }
                        >
                          <span
                            className="material-icons-outlined"
                            style={{ fontSize: "18px", color: "#555" }}
                          >
                            content_copy
                          </span>
                        </button>
                      </div>
                    </TableBodyItem>
                  )}
                  {String(userData?.collabo) === "0" && (
                    <TableBodyItem
                      isKeepAll={true}
                      clickable={d?.uid > 0 ? true : false}
                      onClick={() => {
                        if (d?.uid > 0) {
                          setFilter((prev) => ({ ...prev, page }));
                          navigate(`/users/info/${d?.uid ?? 0}`);
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <span>{d?.uid ?? "-"}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                              String(d?.uid ?? ""),
                            );
                            toast.success("UID가 복사되었습니다.");
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "8px 14px",
                            backgroundColor: "#F5F5F5",
                            border: "1px solid #E0E0E0",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                            fontSize: "13px",
                            fontWeight: 500,
                            color: "#555",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#D0D0D0")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#F5F5F5")
                          }
                        >
                          <span
                            className="material-icons-outlined"
                            style={{ fontSize: "18px", color: "#555" }}
                          >
                            content_copy
                          </span>
                        </button>
                      </div>
                    </TableBodyItem>
                  )}
                  <TableBodyItem isKeepAll={true} clickable={false}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      <span>{d?.name ?? "-"}</span>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(d?.name ?? "");
                          toast.success("이름이 복사되었습니다.");
                        }}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "8px 14px",
                          backgroundColor: "#F5F5F5",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#555",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#D0D0D0")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#F5F5F5")
                        }
                      >
                        <span
                          className="material-icons-outlined"
                          style={{ fontSize: "18px", color: "#555" }}
                        >
                          content_copy
                        </span>
                      </button>
                    </div>
                  </TableBodyItem>
                  {/* 닉네임 */}
                  <TableBodyItem isKeepAll={true} clickable={false}>
                    {d?.nickname ?? "-"}{" "}
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(d?.nickname ?? "");
                        toast.success("닉네임이 복사되었습니다.");
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "8px 14px",
                        backgroundColor: "#F5F5F5",
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#555",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#D0D0D0")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#E8E8E8")
                      }
                    >
                      {" "}
                      <span
                        className="material-icons-outlined"
                        style={{ fontSize: "18px", color: "#555" }}
                      >
                        content_copy
                      </span>
                    </button>
                    {d?.gptUseMyAcc === false && (
                      <span
                        style={{
                          padding: "4px 8px",
                          borderRadius: "16px",
                          backgroundColor:
                            d?.gptUseMyAcc === null
                              ? "#616161"
                              : d?.gptUseMyAcc
                                ? "#2E7D32"
                                : "#1565C0",
                          // fontWeight: "bold",
                          color: "#fff",
                          fontSize: "10px",
                        }}
                      >
                        {d?.gptUseMyAcc === null
                          ? "-"
                          : d?.gptUseMyAcc
                            ? ""
                            : "N"}
                      </span>
                    )}
                  </TableBodyItem>

                  {/* 파티기간 */}
                  {/* <TableBodyItem isKeepAll={true} clickable={false}>
                    {"12개월"}
                  </TableBodyItem> */}

                  {/* 목표일 */}
                  {/* <TableBodyItem isKeepAll={true} clickable={false}>
                    {d?.duedate
                      ? dayjs(d?.duedate ?? undefined)?.format("YYYY-MM-DD")
                      : "-"}
                  </TableBodyItem> */}

                  {/* 아이디 */}
                  <TableBodyItem>
                    {d?.shareid ? (
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0",
                          backgroundColor: "#FAFAFA",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <button
                          onClick={() => {
                            if (d?.ytstate === 1) {
                              return toast.error(
                                "접수 예정 상태 입니다. 접수중으로 변경하고 시작하세요",
                              );
                            }
                            navigator.clipboard.writeText(
                              d?.shareid.replace(/\s/g, ""),
                            );
                            toast.success("ID가 복사되었습니다.");
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "8px 10px",
                            backgroundColor: "#E8E8E8",
                            border: "none",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#D0D0D0")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#E8E8E8")
                          }
                        >
                          <span
                            className="material-icons-outlined"
                            style={{ fontSize: "18px", color: "#555" }}
                          >
                            content_copy
                          </span>
                        </button>
                      </div>
                    ) : (
                      <span>-</span>
                    )}
                  </TableBodyItem>

                  {/* 처리완료 or 취소이면 pw 를 안보이게 */}
                  {d.ytstate === 3 || d.ytstate === 6 ? (
                    <TableBodyItem isKeepAll={true}>{"-"}</TableBodyItem>
                  ) : (
                    <TableBodyItem isKeepAll={true}>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            decryptPW(d.password, d?.uid).pw.replace(/\s/g, ""),
                          );
                          toast.success("PW가 복사되었습니다.");
                        }}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "8px 14px",
                          backgroundColor: "#F5F5F5",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#555",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#E0E0E0")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#F5F5F5")
                        }
                      >
                        <span
                          className="material-icons-outlined"
                          style={{ fontSize: "16px" }}
                        >
                          content_copy
                        </span>
                      </button>
                    </TableBodyItem>
                  )}

                  <TableBodyItem isKeepAll={true}>
                    {d?.createdate
                      ? dayjs(d?.createdate ?? undefined)?.format(
                          "YYYY.MM.DD HH:mm",
                        )
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.updatedate
                      ? dayjs(d?.updatedate ?? undefined)?.format(
                          "YYYY.MM.DD HH:mm",
                        )
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.admin?.length > 0 ? d?.admin : "-"}
                  </TableBodyItem>

                  <TableBodyItem>
                    <LineBtn
                      btnText="코멘트 작성"
                      btnClickEvent={() =>
                        setCommentInputModal({
                          visible: true,
                          uid: d?.uid,
                          name: "",
                          nickname: d?.nickname ?? "",
                          partyid: d?.partyid ?? 0,
                          servsubsid: d?.servsubsid ?? 0,
                        })
                      }
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response?.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0,
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <SpaceBetween>
        <div />
      </SpaceBetween>

      {viewLog?.modal && (
        <GPTSoloLogModal
          closeEvent={() =>
            setViewLog({
              modal: false,
              partyid: 0,
            })
          }
          // confirmEvent={() => closeEvent()}
          partyid={viewLog?.partyid}
        />
      )}

      {updateModal.visible && (
        <GPTSoloUpdateModal
          closeEvent={() =>
            setUpdateModal({
              visible: false,
              data: {} as IYoutube,
              servsubsid: undefined,
            })
          }
          confirmEvent={() => {
            setUpdateModal({
              visible: false,
              data: {} as IYoutube,
              servsubsid: undefined,
            });
            fetchData({
              method: "get",
              url: buildProxyPartyUrl(),
            });
          }}
          uid={updateModal?.data?.uid}
          partyid={updateModal?.data?.partyid}
          ytstate={updateModal?.data?.ytstate}
          servsubsid={updateModal?.servsubsid ?? 0}
          dueDate={updateModal?.data?.duedate}
        />
      )}

      {commentInputModal.visible && (
        <GPTSoloCommentInputModal
          closeEvent={() =>
            setCommentInputModal({
              visible: false,
              uid: 0,
              name: "",
              nickname: "",
              partyid: 0,
              servsubsid: 0,
            })
          }
          confirmEvent={(content: string) => {
            const inputData = { ...commentInputModal };
            setCommentInputModal({
              visible: false,
              uid: 0,
              name: "",
              nickname: "",
              partyid: 0,
              servsubsid: 0,
            });
            setCommentModal({
              visible: true,
              uid: inputData.uid,
              name: inputData.name,
              nickname: inputData.nickname,
              partyid: inputData.partyid,
              servsubsid: inputData.servsubsid,
              content,
            });
          }}
        />
      )}

      {commentModal.visible && (
        <CommentModal
          closeEvent={() =>
            setCommentModal({
              visible: false,
              uid: 0,
              name: "",
              nickname: "",
              partyid: 0,
              servsubsid: 0,
              content: "",
            })
          }
          confirmEvent={() =>
            setCommentModal({
              visible: false,
              uid: 0,
              name: "",
              nickname: "",
              partyid: 0,
              servsubsid: 0,
              content: "",
            })
          }
          type="input"
          commentData={
            {
              uid: commentModal.uid,
              name: commentModal.name,
              nickname: commentModal.nickname,
              partyId: String(commentModal.partyid),
              servsubsid: commentModal.servsubsid,
              content: commentModal.content,
            } as any
          }
        />
      )}

      {loading && <Loader />}
    </>
  );
}

const MatchingTabContainer = styled(PointTabContainer)`
  margin-bottom: 18px;
`;

const MatchingTabText = styled(PointTabText)`
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 3px solid
    ${({ isActive, theme }) =>
      isActive ? theme.color.gray900 : "transparent"};
`;
